//#region src/user_right.ts
/**
* @see When adding a new right, we need to remember to add it to all existing user roles including
* ~bite~ roles. Then all users with affected roles will need to be updated to get the new rights.
*/
var UserRight = /* @__PURE__ */ function(UserRight) {
	UserRight[UserRight["SendOrderToLivePos"] = 2] = "SendOrderToLivePos";
	UserRight[UserRight["KioskRight"] = 10] = "KioskRight";
	UserRight[UserRight["FlashRight"] = 11] = "FlashRight";
	UserRight[UserRight["ApiToken"] = 12] = "ApiToken";
	UserRight[UserRight["RefundOrders"] = 20] = "RefundOrders";
	UserRight[UserRight["ControlKiosk"] = 21] = "ControlKiosk";
	UserRight[UserRight["ViewOrders"] = 25] = "ViewOrders";
	UserRight[UserRight["AllVendorAccess"] = 27] = "AllVendorAccess";
	UserRight[UserRight["ViewMenuLibrary"] = 28] = "ViewMenuLibrary";
	UserRight[UserRight["Reporting"] = 30] = "Reporting";
	UserRight[UserRight["VerifyAlcoholPurchases"] = 34] = "VerifyAlcoholPurchases";
	UserRight[UserRight["Items86"] = 38] = "Items86";
	UserRight[UserRight["ManageMenu"] = 40] = "ManageMenu";
	UserRight[UserRight["ManageOpenHours"] = 41] = "ManageOpenHours";
	UserRight[UserRight["ManageLowerUsers"] = 45] = "ManageLowerUsers";
	UserRight[UserRight["ManageMenuCovers"] = 46] = "ManageMenuCovers";
	UserRight[UserRight["ManageDiscounts"] = 47] = "ManageDiscounts";
	UserRight[UserRight["EditMenuAppearance"] = 50] = "EditMenuAppearance";
	UserRight[UserRight["ManageChannelSettings"] = 51] = "ManageChannelSettings";
	UserRight[UserRight["ToggleDiningOptions"] = 52] = "ToggleDiningOptions";
	UserRight[UserRight["ShowFlashClosedScreen"] = 56] = "ShowFlashClosedScreen";
	UserRight[UserRight["ManageBiteLift"] = 57] = "ManageBiteLift";
	UserRight[UserRight["ManageOrderThrottling"] = 60] = "ManageOrderThrottling";
	UserRight[UserRight["ManageCustomers"] = 65] = "ManageCustomers";
	UserRight[UserRight["ManageWebSettings"] = 66] = "ManageWebSettings";
	UserRight[UserRight["ManageCateringSettings"] = 67] = "ManageCateringSettings";
	UserRight[UserRight["ManageOtherUsersChangeset"] = 68] = "ManageOtherUsersChangeset";
	UserRight[UserRight["ViewActivities"] = 71] = "ViewActivities";
	UserRight[UserRight["ManageI9nLite"] = 72] = "ManageI9nLite";
	UserRight[UserRight["ViewSystemLogsLite"] = 73] = "ViewSystemLogsLite";
	UserRight[UserRight["DeleteCustomers"] = 82] = "DeleteCustomers";
	UserRight[UserRight["ManageBrandColorAndLogo"] = 83] = "ManageBrandColorAndLogo";
	UserRight[UserRight["ManageThirdPartyPrivacyPolicy"] = 84] = "ManageThirdPartyPrivacyPolicy";
	UserRight[UserRight["Admin"] = 89] = "Admin";
	UserRight[UserRight["MagicCopyLocation"] = 90] = "MagicCopyLocation";
	UserRight[UserRight["CreateSitesAndChannels"] = 91] = "CreateSitesAndChannels";
	UserRight[UserRight["ManageI9n"] = 92] = "ManageI9n";
	UserRight[UserRight["ViewSystemLogs"] = 93] = "ViewSystemLogs";
	UserRight[UserRight["ManageSupportedLanguages"] = 94] = "ManageSupportedLanguages";
	UserRight[UserRight["ManageKiosks"] = 95] = "ManageKiosks";
	UserRight[UserRight["ManageCommonSettings"] = 96] = "ManageCommonSettings";
	UserRight[UserRight["ManageMenuAdvanced"] = 97] = "ManageMenuAdvanced";
	UserRight[UserRight["BiteAccess"] = 100] = "BiteAccess";
	UserRight[UserRight["BiteSupport"] = 110] = "BiteSupport";
	UserRight[UserRight["BiteOps"] = 120] = "BiteOps";
	UserRight[UserRight["ManageLowerBiteUsers"] = 130] = "ManageLowerBiteUsers";
	UserRight[UserRight["BiteEng"] = 150] = "BiteEng";
	UserRight[UserRight["BiteAdmin"] = 200] = "BiteAdmin";
	UserRight[UserRight["ApiTokenReporting"] = 300] = "ApiTokenReporting";
	UserRight[UserRight["ApiTokenMobileApp"] = 301] = "ApiTokenMobileApp";
	UserRight[UserRight["ApiTokenLocations"] = 302] = "ApiTokenLocations";
	return UserRight;
}(UserRight || {});
//#endregion
export { UserRight };

//# sourceMappingURL=user_right.js.map